import { useState } from "react";
import { supabase } from "../supabaseClient";

function CreateProfileModal({ onClose }) {

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [username,setUsername] = useState("");

const handleCreateAccount = async () => {

  if (!email || !password || !username) {
    alert("All fields required");
    return;
  }

  // check username availability
  const { data: existing } = await supabase
    .from("profiles")
    .select("username")
    .eq("username", username)
    .maybeSingle();

  if (existing) {
    alert("Username already taken");
    return;
  }

  // create auth account
  const { error } = await supabase.auth.signUp({
    email,
    password
  });

  if (error) {
    alert(error.message);
    return;
  }

  // get the authenticated user
  const { data: userData } = await supabase.auth.getUser();

  const userId = userData?.user?.id;

  if (userId) {
    await supabase
      .from("profiles")
      .update({ username })
      .eq("id", userId);
  }

  alert("Account Created! Welcome to SkateSpotter.");

  onClose();
};

  return (
   <div style={modalOverlay}>
  <div style={modalCard}>

    <h2 style={title}>Create Account</h2>

    <input
      placeholder="Username"
      value={username}
      onChange={(e) => setUsername(e.target.value)}
      style={input}
    />

    <input
      placeholder="Email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      style={input}
    />

    <input
      type="password"
      placeholder="Password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      style={input}
    />

    <div style={buttonContainer}>
      <button style={primaryButton} onClick={handleCreateAccount}>
        Continue
      </button>

      <button style={secondaryButton} onClick={onClose}>
        Cancel
      </button>
    </div>

  </div>
</div>
  );
}

export default CreateProfileModal;


const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 20000
};

const modalCard = {
  width: "90%",
  maxWidth: "420px",
  padding: "28px",
  borderRadius: "16px",
  background: "rgba(28,28,30,0.95)",
  backdropFilter: "blur(20px)",
  boxShadow: "0 20px 40px rgba(0,0,0,0.6)"
};

const title = {
  fontSize: "26px",
  fontWeight: "700",
  color: "white",
  marginBottom: "20px",
  textAlign: "center"
};

const input = {
  width: "100%",
  padding: "14px",
  marginBottom: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#2c2c2e",
  color: "white",
  fontSize: "16px"
};

const buttonContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "14px",
  marginTop: "10px"
};

const primaryButton = {
  padding: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#0a84ff",
  color: "white",
  fontWeight: "700",
  fontSize: "16px",
  cursor: "pointer"
};

const secondaryButton = {
  padding: "14px",
  borderRadius: "12px",
  border: "none",
  background: "#3a3a3c",
  color: "white",
  fontWeight: "600",
  fontSize: "16px",
  cursor: "pointer"
};